/**
 * SD500 / EMD500E kit-request draft + accept endpoints.
 * Kept outside orval until the swagger spec is regenerated.
 */
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { customInstance } from './mutators/axios-instance'

export interface Sd500KitRequestRecord {
  _id: string
  submissionId: string
  kitRequestStatus?: 'draft' | 'accepted'
  [key: string]: unknown
}

export type KitRequestApiPayload = {
  submissionId: string
  requestor: Record<string, unknown>
  quantity: Record<string, number>
}

export async function upsertSd500KitRequestDraft(
  data: KitRequestApiPayload,
): Promise<Sd500KitRequestRecord> {
  const response = await customInstance<Sd500KitRequestRecord>({
    url: '/sd500-emd500e/kit-request/draft',
    method: 'POST',
    data,
  })
  return response.data
}

export async function acceptSd500KitRequest(
  kitRequestId: string,
  data: { submissionId: string },
): Promise<Sd500KitRequestRecord> {
  const response = await customInstance<Sd500KitRequestRecord>({
    url: `/sd500-emd500e/kit-request/${kitRequestId}/accept`,
    method: 'POST',
    data,
  })
  return response.data
}

export function useUpsertSd500KitRequestDraft(
  options?: {
    mutation?: UseMutationOptions<
      Sd500KitRequestRecord,
      unknown,
      { data: KitRequestApiPayload },
      unknown
    >
  },
) {
  return useMutation({
    mutationFn: ({ data }) => upsertSd500KitRequestDraft(data),
    ...options?.mutation,
  })
}

export function useAcceptSd500KitRequest(
  options?: {
    mutation?: UseMutationOptions<
      Sd500KitRequestRecord,
      unknown,
      { kitRequestId: string; data: { submissionId: string } },
      unknown
    >
  },
) {
  return useMutation({
    mutationFn: ({ kitRequestId, data }) => acceptSd500KitRequest(kitRequestId, data),
    ...options?.mutation,
  })
}
